import React, { useCallback } from 'react';
import TableControlsColumn from './TableControlsColumn';

/**
 * Builds the rows in the format that react-virtualized expects them to be in.
 * 
 * react-virtualized uses this to fetch the row at a specified index. It handles the indexing itself.
 * The index matches tableRows[index] however this row may or may not be rendered on the page depending on the scroll.
 * E.g. you can have row 5 as the first rendered row, and row 4 may not be rendered at all.
 * 
 * If the table supports controls - delete, edit, and does not disable delete, then this function will
 * attach an additional control column - as long as the specific row does not disalbe controls.
 * E.g. its possible for a specific row to disable the controls for itself, or to implement custom controls column.
 * 
 * @param {*} tableRows - the original rows we pass in our own format to the table component before converting them to the react-virtualized format
 * @param {*} tableShowControls  - boolean indicating whether the table should show edit/delete, etc buttons for each row. Each row may disable those buttons on its own as well.
 * @returns 
 */
const useRowGetter = _ref => {
  let {
    tableRows,
    tableShowControls,
    tableIsImmutableUnderReview,
    tableOnDelete,
    tableOnEdit,
    tableDisableDelete
  } = _ref;
  const rowGetter = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    const originalTableRow = tableRows[index];
    const virtualizedRowObject = {};
    let currentColumnIndex = 0;
    originalTableRow.columns.forEach((columnContent, columnIndex) => {
      virtualizedRowObject[columnIndex] = columnContent;
      currentColumnIndex = columnIndex;
    });
    if (tableShowControls) {
      currentColumnIndex += 1;
      virtualizedRowObject[currentColumnIndex] = /*#__PURE__*/React.createElement(TableControlsColumn, {
        key: index // this is required as otherwise it just renders this for the first row.
        ,
        originalTableRow: originalTableRow,
        rowVirtualIndex: index,
        tableIsImmutableUnderReview: tableIsImmutableUnderReview,
        tableOnDelete: tableOnDelete,
        tableOnEdit: tableOnEdit,
        tableDisableDelete: tableDisableDelete
      });
    }
    return virtualizedRowObject;
  }, [tableDisableDelete, tableIsImmutableUnderReview, tableOnDelete, tableOnEdit, tableRows, tableShowControls]);
  return rowGetter;
};
export default useRowGetter;